/**
 * PromptPay QR payload builder (EMVCo QR / Thai PromptPay spec).
 *
 * Accepts either a 10-digit phone number or 13-digit national ID.
 * For dynamic QR (with amount), sets tag 01 = "12"; otherwise "11".
 */

function crc16(data) {
  let crc = 0xFFFF;
  for (let i = 0; i < data.length; i++) {
    crc ^= data.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) : (crc << 1);
      crc &= 0xFFFF;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

/**
 * Mask a PromptPay id for anything a customer walks out with.
 *
 * Keeps the first 3 and last 3 digits — enough for the payer to recognise the
 * shop's number and to match it against their transfer slip, without printing
 * a full mobile number / national id on paper that ends up in a bin.
 * 0982299881 → 098xxxx881.
 *
 * Handles all three PromptPay id lengths (10 mobile / 13 national id / 15
 * e-wallet) by masking whatever sits in the middle. The QR itself still carries
 * the real number, so this is about casual leakage, not secrecy.
 */
export function maskPromptPayId(id) {
  const digits = String(id || '').replace(/\D/g, '');
  if (digits.length <= 6) return digits; // too short to mask and still be useful
  return digits.slice(0, 3) + 'x'.repeat(digits.length - 6) + digits.slice(-3);
}

export function generatePromptPayPayload(target, amount, merchantName, merchantCity) {
  const tag = (id, value) => id + value.length.toString().padStart(2, '0') + value;
  const digits = String(target || '').replace(/\D/g, '');

  let acctTag;
  let acctValue;
  if (digits.length === 13) {
    acctTag = '02';
    acctValue = digits;
  } else {
    acctTag = '01';
    const mobile = digits.replace(/^0+/, '');
    acctValue = ('0000000000000' + '66' + mobile).slice(-13);
  }

  const merchant = tag('00', 'A000000677010111') + tag(acctTag, acctValue);
  // Tags 59/60 must be ASCII, max 25/15 chars
  const name = String(merchantName || '').replace(/[^\x20-\x7E]/g, '').slice(0, 25);
  const city = String(merchantCity || '').replace(/[^\x20-\x7E]/g, '').slice(0, 15);

  const payload =
    tag('00', '01')
    + tag('01', amount ? '12' : '11')
    + tag('29', merchant)
    + tag('53', '764')
    + (amount ? tag('54', parseFloat(amount).toFixed(2)) : '')
    + tag('58', 'TH')
    + (name ? tag('59', name) : '')
    + (city ? tag('60', city) : '')
    + '6304';

  return payload + crc16(payload);
}
